module.exports = __webpack_public_path__ + "static/media/48_A.6fc1d599.png";